import { IConfiguration } from "models/configurations.models";
import { QueryAPIKey } from "utils/constants/api.constants";
import queries from "../../queries";

export const configurationsQueryConfig = {
  getConfigurations: {
    query: queries.configurations.configurations,
    queryKey: [QueryAPIKey.GetConfigurations],
    errorMessageKey: "getConfigurationsFailure",
    queryOptions: {
      select: ({
        configurations,
      }: {
        configurations: IConfiguration[];
      }): IConfiguration[] => configurations ?? [],
    },
  },
};
